import { cloneDeep, get } from 'lodash-es'
import { SetStateAction } from 'react'
import { useLocalStorage } from 'react-use'

export interface UserPreference {
	isActionTextBlurTransitionEffectEnabled: boolean
	theme: 'DARK' | 'LIGHT' | 'AUTO'
}
const INTIAL_VALUES: UserPreference = {
	isActionTextBlurTransitionEffectEnabled: false,
	theme: 'AUTO',
}
export default function useUserPreference<Key extends keyof UserPreference>(key: Key) {
	const [value, set, remove] = useLocalStorage<UserPreference>('JK_USER_PERFS', INTIAL_VALUES)

	return [
		get(value, key),
		(nextUserPrefValue: SetStateAction<UserPreference[Key]>) => {
			set((prev = INTIAL_VALUES) => {
				const next = cloneDeep(prev)
				if (typeof nextUserPrefValue === 'function') {
					nextUserPrefValue = nextUserPrefValue(next[key])
				}
				next[key] = nextUserPrefValue
				return next
			})
		},
		() => {
			set((prev = INTIAL_VALUES) => {
				const next = cloneDeep(prev)
				delete next[key]
				return next
			})
		},
	] as const
}
